(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eowrap-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFaq = root => {
      if (!root || root.dataset.eoFaqReady === 'true') return;
      root.dataset.eoFaqReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const items = [...root.querySelectorAll('.eo-faq-section__item')];

      const closeItem = item => {
        const button = item.querySelector('.eo-faq-section__question');
        const answer = item.querySelector('.eo-faq-section__answer');
        if (button.getAttribute('aria-expanded') !== 'true') return;
        button.setAttribute('aria-expanded', 'false');
        item.classList.remove('is-open');
        if (reducedMotion) {
          answer.style.maxHeight = '0px';
          answer.hidden = true;
          return;
        }
        answer.style.maxHeight = `${answer.scrollHeight}px`;
        requestAnimationFrame(() => { answer.style.maxHeight = '0px'; });
      };

      const openItem = item => {
        const button = item.querySelector('.eo-faq-section__question');
        const answer = item.querySelector('.eo-faq-section__answer');
        items.forEach(other => { if (other !== item) closeItem(other); });
        answer.hidden = false;
        button.setAttribute('aria-expanded', 'true');
        item.classList.add('is-open');
        answer.style.maxHeight = reducedMotion ? 'none' : `${answer.scrollHeight}px`;
      };

      items.forEach(item => {
        const button = item.querySelector('.eo-faq-section__question');
        const answer = item.querySelector('.eo-faq-section__answer');
        button.addEventListener('click', () => {
          if (button.getAttribute('aria-expanded') === 'true') closeItem(item);
          else openItem(item);
        });
        answer.addEventListener('transitionend', event => {
          if (event.propertyName === 'max-height' && button.getAttribute('aria-expanded') === 'false') answer.hidden = true;
        });
        if (button.getAttribute('aria-expanded') === 'true') openItem(item);
        else answer.hidden = true;
      });

      window.addEventListener('resize', () => {
        const openAnswer = root.querySelector('.eo-faq-section__item.is-open .eo-faq-section__answer');
        if (openAnswer && !reducedMotion) openAnswer.style.maxHeight = `${openAnswer.scrollHeight}px`;
      });
    };

    document.querySelectorAll('[data-eo-faq-section]').forEach(initializeFaq);
    document.addEventListener('shopify:section:load', event => initializeFaq(event.target.querySelector('[data-eo-faq-section]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
